import { Skeleton } from "@mui/material";

/** LoadableText component, used to display a skeleton or the text based on a trigger */
export const LoadableText = ({ text, trigger = true }) => (text && trigger ? text : <Skeleton width={"100%"} />);
